import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "home",
  class: "relative min-h-screen overflow-hidden"
}
const _hoisted_2 = ["src", "alt", "loading"]
const _hoisted_3 = { class: "absolute inset-0 z-10 flex items-center py-20 px-6 sm:px-8 lg:px-12" }
const _hoisted_4 = { class: "container mx-auto max-w-7xl" }
const _hoisted_5 = { class: "max-w-2xl" }
const _hoisted_6 = { class: "text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 animate-fade-in leading-tight" }
const _hoisted_7 = { class: "text-lg sm:text-xl md:text-2xl text-white/95 mb-10 animate-fade-in-delay leading-relaxed" }
const _hoisted_8 = { class: "flex flex-col sm:flex-row gap-4 animate-fade-in-delay-2" }
const _hoisted_9 = {
  href: "https://docs.google.com/forms/d/e/1FAIpQLSfFWo4Kbs87MZuRUMjLMV9fLjF7lfOCwzbFJ_wenR6yuEqAPQ/viewform",
  target: "_blank",
  rel: "noopener noreferrer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: 'slide-' + index,
        class: _normalizeClass(['absolute inset-0 min-h-screen transition-opacity duration-1000', _ctx.currentSlide === index ? 'opacity-100' : 'opacity-0'])
      }, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "absolute inset-0 bg-black/60" }, null, -1)),
        _createElementVNode("img", {
          src: slide.image,
          alt: slide.title,
          loading: index === 0 ? 'eager' : 'lazy',
          class: "w-full h-full min-h-screen object-cover object-center"
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h1", _hoisted_6, _toDisplayString(slide.title), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(slide.subtitle), 1),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("a", _hoisted_9, [
                  _createVNode(_component_Button, {
                    size: "lg",
                    class: "bg-primary hover:bg-accent text-white px-8 py-4 text-lg font-semibold shadow-xl hover:shadow-2xl transition-all duration-300 w-full sm:w-auto"
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode(" Get Involved ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createVNode(_component_Button, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/about'))),
                  size: "lg",
                  class: "bg-primary hover:bg-accent text-white px-8 py-4 text-lg font-semibold shadow-xl hover:shadow-2xl transition-all duration-300 w-full sm:w-auto"
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode(" Learn More ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ], 2))
    }), 128)),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 animate-bounce" }, [
      _createElementVNode("svg", {
        class: "w-8 h-8 text-white",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [
        _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M19 9l-7 7-7-7"
        })
      ])
    ], -1))
  ]))
}